import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LGH } from "./components/LGH";
import ModalAddInTest from "./components/ModalAddInTest";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../APIs/ForeignData.api";

export function PXKCC() {
  const { lang, functions, proxy } = useSelector((state) => state);
  const { filterData } = functions;

  const [data, setData] = useState();
  const [LXH, setLXH] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [isToggle, setIsToggle] = useState(false);
  const [refreshPage, setRefreshPage] = useState(0);
  const params = useParams();
  const navigate = useNavigate();
  const _token = localStorage.getItem("_token");
  const [selectedValues, setSelectedValues] = useState([]);
  const [getValues, SetValues] = useState({});

  const [inputFields, setInputFields] = useState([
    {
      label: "Mã Phiếu Xuất (ERP)",
      required: true,
      alias: "10MPXK",
      readOnly: true,
    },
    // {
    //   label: "Mã Phiếu Xuất Kho ERP",
    //   alias: "maPhieuXuatKhoERP",
    //   type: "text",
    // },
    { label: "Ngày Xuất", alias: "6NXH", type: "datetime-local" },
    {
      label: "Phương Tiện",
      alias: "4PT",
      type: "select",
      table_id: 174087,
      displayFields: ["1MPT", "41MT"],
      isPK: "1MPT",
    },
    { label: "STT Ghe/Xe", alias: "1SPT", type: "text" },
    { label: "Biển Số Xe/Tàu", alias: "1BSPT", type: "text" },
    { label: "Chủ Xe/Tàu", alias: "1CPT", type: "text" },
    { label: "Đại Diện Bốc Xếp", alias: "2ĐDBX", type: "text" },
    { label: "Người Nhận", alias: "10NN", type: "text" },
    {
      label: "Lý Do Xuất (nếu có trường hợp bán hàng chuyển chủ)",
      alias: "lyDoXuatPXK",
      type: "text",
    },
    {
      label: "Hình Thức PXK ( Chọn giá trị nếu là chuyển chủ)",
      alias: "hinhThucPXK",
      type: "select",
      table_id: 5201379,
      displayFields: ["tenHinhThuc"],
      isPK: "mahinhthuc",
    },
    {
      label: "LXH/LĐĐNB",
      alias: "PP",
      required: true,
      isDisplay: false,
      isFK: {
        state: true,
        child: [
          { value: "lenhXuatHangERP", alias: "lenhXuatHangERP" },
          { value: "5SLCXTT" },
          { value: "28MSP", alias: "25MSP" },
          { value: "deliveryDetailId", alias: "deliveryDetailId" },
        ],
      },
    },
  ]);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${proxy()}/api/PXK/${params.id}`);
        const { data, lxh } = await response.json();
        setData((prev) => {
          const newPrev = prev;
          if (newPrev) {
            return newPrev;
          }
          return data?.[0] || {};
        });
        if (data.length) {
          for (const item of inputFields) {
            // if (data[item.alias]) {
            const opts = [];
            const table_id = item?.table_id;
            const { betChar, isPK } = item;

            if (item.type === "select" || item.type === "input-select") {
              let dataBody = {
                table_id,
                start_index: 0,
                type: "or",
              };

              dataBody["criteria"] = { [isPK]: data[item.alias] };
              dataBody["criteria_type"] = { [item.alias]: "regex" };

              const foreignResponse = await ForeignData_API.get(
                proxy(),
                _token,
                dataBody
              );
              const { data: foreignData = [] } = foreignResponse;
              if (foreignData.length) {
                const result = foreignData.reduce((acc, curr) => {
                  const checkEmpty = Array.isArray(data[item.alias])
                    ? data[0][item.alias].some((item) => item === curr[isPK])
                    : curr[isPK] === data[0][item.alias];

                  if (checkEmpty) {
                    const fields = item?.displayFields?.map(
                      (field) => curr[field]
                    );

                    opts.push({
                      label: fields.join(betChar ? betChar : " | "),
                      value: curr[isPK],
                    });

                    acc.push({
                      label: fields.join(betChar ? betChar : " | "),
                      value: curr[isPK],
                    });
                  }
                  // }
                  return acc;
                }, []);

                if (result.length) {
                  SetValues((prev) => ({
                    ...prev,
                    [item?.alias]: item?.isMulti ? result : result?.[0],
                  }));
                }
              }
            }

            // }
          }
        }
        setLXH(lxh);
      } catch (e) {}
      setIsFetching(false);
    })();
  }, [refreshPage]);

  const handleSubmit = () => {
    fetch(`${proxy()}/api/PXK`, {
      method: "PUT",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
      body: JSON.stringify({
        ...data,
        pathname: window.location.pathname.split("/").filter(Boolean)[0],
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, message } = res;
        if (message) {
          Swal.fire({
            title: lang["fail.update"],
            // text: message,
            html: `<div style="white-space: pre-line;">${message}</div>`,
            // text: message,
            icon: "error",
            showConfirmButton: true,
            // timer: 1500,
            showConfirmButton: true,
            // timer: 1500,
          }).then(async () => {
            // const response = await fetch(`${proxy()}/api/PXK/${params.id}`);
            // const { data } = await response.json();
            // setData(data?.[0] || {});
          });
        }
        if (success) {
          Swal.fire({
            title: lang["success"],
            text: lang["success.update"],
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            setRefreshPage((prev) => prev + 1);
            // setLoadingUpdate(false);
          });
        }
      });
  };

  const loadOptionsLGH = async (page = 0, search = "", items, alias) => {
    return new Promise(async (resolve, reject) => {
      let dataBody = {
        table_id: 22577,
        start_index: page,
        type: "or",
      };

      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };
      dataBody["criteria"] = {
        "2MLXH": search.trim(),
        lenhXuatHangERP: search.trim(),
      };
      dataBody["criteria_type"] = {
        "2MLXH": "regex",
        lenhXuatHangERP: "regex",
      };

      try {
        const response = await fetch(`${proxy()}/api/PXK/optionLGHCC`, {
          method: "POST",
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
          body: JSON.stringify({
            ...dataBody,
            skip: page,
            limit: 100,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }

        const res = await response.json();
        const returnedData = res.data || [];

        const options = returnedData.map((d) => {
          if (items.child?.length) {
            let label = items.child.map(({ value }) => d[value]).join("|");
            return {
              value: d,
              label: label,
            };
          }
          // return {
          //   value: d,
          //   label: d[pk],
          // };
        });

        let hasMoreValue = true;

        if (!returnedData?.length) {
          hasMoreValue = false;
        }
        const aliasSet = new Set(data[alias].map((item) => item["4LXH"]));

        const filteredOptions = options;
        // options.filter((option) => {
        //   const optionValue = option.value["lenhXuatHangERP" || "2MLXH"];
        //   return !aliasSet.has(optionValue);
        // });

        const mapped = filteredOptions.flatMap((item) => {
          const findLXH = LXH.find(
            (lxh) =>
              item.value["lenhXuatHangERP" || "2MLXH"] ===
                lxh["lenhXuatHangERP" || "2MLXH"] &&
              item.value.delivery_detail_id === lxh.delivery_detail_id
          );
          const hasArrayField = items.child.find(({ value }) =>
            Array.isArray(item.value[value])
          )?.value;

          // let label = items.child
          //   .map(({ value }) => item.value[value])
          //   .join("|");

          if (!hasArrayField) {
            return [
              {
                label: items.child
                  .map((field) => item?.value?.[field?.value])
                  .filter(Boolean)
                  .join("|"),
                value: {
                  ...item.value,
                  ...findLXH,
                },
              },
            ];
          }
          const arrayField = hasArrayField;
          const arrayValues = item?.value[arrayField];

          return arrayValues.map((val) => {
            const clonedItem = {
              ...item,
              [arrayField]: val,
              value: { ...item.value, [arrayField]: val },
            };

            return {
              ...findLXH,
              ...clonedItem,
              label: items.child
                .map((field) => clonedItem?.value?.[field.value])
                .filter(Boolean)
                .join("|"),
            };
          });
          // if (findLXH) {
          //   return {
          //     ...item,
          //     value: {
          //       ...item.value,
          //       ...findLXH,
          //     },
          //   };
          // }
        });
        const { PP = [] } = data;
        const mappedData = mapped.filter(
          (item) =>
            !PP.some(
              ({ deliveryDetailId, "4LXH": lxh }) =>
                lxh === item.value["2MLXH"] &&
                deliveryDetailId === item.value.deliveryDetailId
            )
        );

        newData = {
          options: mappedData,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 100 : page,
          },
        };

        setTimeout(() => {
          resolve(filterData(newData, search));
        }, 100);
      } catch (error) {
        console.error("Error in loadOptions:", error);
        reject(error);
      }
    });
  };

  const handleChange = ({ alias, index }, value) => {
    setData((prev) => {
      const newPrev = { ...prev };
      if (newPrev?.[alias]?.[index]) {
        newPrev[alias][index] = {
          ...newPrev[alias][index],
          ...value,
        };
      } else {
        newPrev[alias].push({
          ...value,
        });
      }
      return newPrev;
    });
  };

  if (isFetching) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          height: "75vh",
        }}
      >
        <img
          width={35}
          className="mb-1"
          src="/images/icon/load.gif"
          alt="Loading..."
        ></img>
      </div>
    );
  }
  const goBack = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="midd_cont" key={refreshPage}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => goBack()}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link"></i>
                        </a>
                        Phiếu Xuất Kho Chuyển Chủ
                        {/* {functions.findPropsNameUpdateByUrl(page, checkIdStr)} */}
                        <i className="fa fa-chevron-right ml-2 mr-1"></i>
                        {lang["update"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12">
                    <div
                      className="w-50-pct mg-auto p-1 bg-white input-put"
                      style={{
                        height: "70vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {inputFields.map(
                        (
                          {
                            label,
                            alias,
                            required,
                            btn,
                            child,
                            isDisplay = true,
                            type,
                            isFK,
                            readOnly,
                            table_id,
                            displayFields,
                            isPK,
                          },
                          index
                        ) => {
                          let value = data?.[alias];
                          // let value =
                          //   type === "datetime-local"
                          //     ? moment
                          //         .utc(data[alias])
                          //         .format("DD/MM/YYYY HH:mm:ss")
                          //     : data[alias];
                          if (type === "datetime-local") {
                            let date = new Date(value);
                            if (date !== "Invalid Date" && value) {
                              let localISOTime = moment
                                .utc(value)
                                .toISOString()
                                .slice(0, 19);
                              value = localISOTime;
                              // console.log("localISOTime", localISOTime);
                              // setCurrent(localISOTime);
                            }
                          }
                          if (type === "select") {
                            return (
                              <div className="row justify-content-center">
                                <div className="col-md-8 mb-3" key={index}>
                                  <label>
                                    {label}
                                    {required && (
                                      <span style={{ color: "red" }}>*</span>
                                    )}
                                  </label>
                                  <AsyncPaginate
                                    className="mb-0 w-100"
                                    loadOptions={async (
                                      search,
                                      loadedOptions,
                                      { page }
                                    ) => {
                                      return await loadOptions(
                                        page,
                                        search,
                                        displayFields,
                                        table_id,
                                        proxy,
                                        isPK
                                      );
                                    }}
                                    value={getValues[alias]}
                                    onChange={(opts) => {
                                      SetValues((prev) => ({
                                        ...prev,
                                        [alias]: opts,
                                      }));
                                      setData((prev) => {
                                        let newPrev = { ...prev };
                                        newPrev[alias] = opts?.value || "";
                                        return newPrev;
                                      });
                                    }}
                                    additional={{ page: 0 }}
                                    isSearchable={true}
                                    allowCreateWhileLoading={false}
                                    noOptionsMessage={() => (
                                      <div style={{ fontWeight: "300" }}>
                                        {lang["not found data"]}
                                      </div>
                                    )}
                                    isClearable={true}
                                    styles={{
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    placeholder={lang["select value"]}
                                  />
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div className="row justify-content-center">
                              <div className="col-md-8 mb-3" key={index}>
                                <label>
                                  {label}
                                  {required && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>
                                <div className="d-flex">
                                  {isFK?.state ? (
                                    <>
                                      <AsyncPaginate
                                        placeholder={lang["select value"]}
                                        isMulti
                                        isSearchable={true}
                                        loadOptions={async (
                                          search,
                                          loadedOptions,
                                          { page }
                                        ) => {
                                          return await loadOptionsLGH(
                                            page,
                                            search,
                                            isFK,
                                            alias
                                          );
                                        }}
                                        components={{
                                          DropdownIndicator: () => null,
                                          ClearIndicator: () => null,
                                          MultiValueRemove: () => null,
                                        }}
                                        // onKeyDown={(e) =>
                                        //   e.preventDefault()
                                        // }
                                        value={selectedValues}
                                        onChange={async (opts) => {
                                          const { data: SanPham } = await fetch(
                                            proxy() + `/api/PXK/inforLGH`,
                                            {
                                              method: "POST",
                                              headers: {
                                                Authorization: _token,
                                                "content-type":
                                                  "application/json",
                                              },
                                              body: JSON.stringify({
                                                msp: opts.map(
                                                  (item) =>
                                                    item?.value?.["msp"] ||
                                                    item?.value?.["28MSP"]
                                                      ?.MaSP ||
                                                    item?.["28MSP"]
                                                ),
                                              }),
                                            }
                                          ).then((res) => res.json());

                                          const updatedOpts = opts.map(
                                            (opt, i) => {
                                              let newValue = {
                                                ...opt.value,
                                              };
                                              isFK?.child?.map((item) => {
                                                if (opt.value[item.value]) {
                                                  newValue[item.alias] =
                                                    opt.value[item.value];
                                                }
                                              });
                                              const sp = SanPham.find(
                                                ({ MaSP }) =>
                                                  MaSP === opt.value["25MSP"]
                                              );

                                              return {
                                                label: opt.label,
                                                ...newValue,
                                                "25MSP": {
                                                  TenSP:
                                                    sp?.TenSP ||
                                                    SanPham[i]?.TenSP,
                                                  MaSP:
                                                    sp?.MaSP ||
                                                    SanPham[i]?.MaSP,
                                                },
                                              };
                                            }
                                          );
                                          setData((prev) => {
                                            const newPrev = { ...prev };

                                            if (newPrev[alias]) {
                                              const filteredAlias = newPrev[
                                                alias
                                              ].filter(
                                                (item) =>
                                                  !item.label ||
                                                  opts.some(
                                                    (opt) =>
                                                      opt.label ===
                                                        item.label &&
                                                      opt?.value
                                                        ?.deliveryDetailId ===
                                                        item?.deliveryDetailId
                                                  )
                                              );

                                              const updatedAlias = [
                                                ...filteredAlias,
                                                ...updatedOpts.filter(
                                                  (opt) =>
                                                    !filteredAlias.some(
                                                      (item) =>
                                                        item.label === opt.label
                                                    )
                                                ),
                                              ];
                                              setSelectedValues(opts);
                                              return {
                                                ...newPrev,
                                                [alias]: updatedAlias,
                                              };
                                            }

                                            return {
                                              ...newPrev,
                                              [alias]: updatedOpts,
                                            };
                                          });
                                        }}
                                        styles={{
                                          container: (base) => ({
                                            ...base,
                                            width: "100%",
                                          }),
                                          menuList: (base) => ({
                                            ...base,
                                            maxHeight: "300px",
                                          }),
                                          menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        additional={{
                                          page: 0,
                                        }}
                                        noOptionsMessage={() => (
                                          <div style={{ fontWeight: "300" }}>
                                            {lang["not found data"]}
                                          </div>
                                        )}
                                      />
                                    </>
                                  ) : (
                                    <input
                                      className="form-control"
                                      type={type}
                                      defaultValue={isDisplay ? value : ""}
                                      onChange={(e) => {
                                        const { value } = e.target;
                                        setData((prev) => {
                                          let newPrev = prev;
                                          newPrev = {
                                            ...newPrev,
                                            [alias]: value,
                                          };
                                          // console.log("WHATHREE", newPrev);
                                          return newPrev;
                                        });
                                      }}
                                      readOnly={readOnly}
                                    />
                                  )}
                                  {!isDisplay ? (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setIsToggle(true);
                                      }}
                                      className="btn btn-success mt-0 ml-3"
                                      data-toggle="modal"
                                      data-target="#renderModalTest"
                                      data-backdrop="static"
                                    >
                                      {lang["add"]}
                                    </button>
                                  ) : null}
                                </div>
                                <div>
                                  {!isDisplay ? (
                                    <LGH
                                      key={refreshPage}
                                      data={data[alias]}
                                      handleChange={handleChange}
                                      alias={alias}
                                      setData={setData}
                                      fields={inputFields}
                                      setSelectedValues={setSelectedValues}
                                      LXH={LXH}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div className="row justify-content-center">
                      <div className="col-md-8">
                        <div className="mt-2 d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-success mr-2"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => handleSubmit()}
                          >
                            Lưu lại
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger mr-2"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => navigate(-1)}
                          >
                            Đóng
                          </button>
                        </div>
                      </div>
                    </div>
                    {isToggle ? (
                      <ModalAddInTest
                        setIsToggle={setIsToggle}
                        data={data}
                        handleChange={handleChange}
                        fields={inputFields}
                        setRefreshPage={setRefreshPage}
                        setSelectedValues={setSelectedValues}
                        LXH={LXH}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const loadOptions = async (
  page = 0,
  search = "",
  displayFields,
  table_id,
  proxy,
  isPK,
  isApi,
  isClone
) => {
  return new Promise(async (resolve, reject) => {
    let dataBody = {
      table_id,
      start_index: page,
      type: "or",
    };

    let newData = {
      options: [],
      hasMore: false,
      additional: {
        page: 0,
      },
    };
    if (search) {
      let criteria = {};
      let criteria_type = {};
      displayFields.forEach((field) => {
        criteria[field] = search.trim();
        criteria_type[field] = "regex";
      });

      dataBody.criteria = criteria;
      dataBody.criteria_type = criteria_type;
    }

    const _token = localStorage.getItem("_token");
    try {
      const { data } = isApi
        ? await fetch(proxy() + isApi, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
              "data-amount": 100,
            },
            body: JSON.stringify(dataBody),
          }).then((res) => res.json())
        : await ForeignData_API.get(proxy(), _token, dataBody);
      let hasMoreValue = true;

      if (!data?.length) {
        hasMoreValue = false;
      }

      if (data.length) {
        const options = data.flatMap((item) => {
          const hasArrayField = displayFields.find((field) =>
            Array.isArray(item[field])
          );
          if (!hasArrayField) {
            return [
              {
                label: displayFields
                  .map((field) => item[field])
                  .filter(Boolean)
                  .join("|"),
                value: item?.[isPK],
                ...item,
              },
            ];
          }

          const arrayField = hasArrayField;
          const arrayValues = item[arrayField];

          return !isClone
            ? [
                {
                  label: displayFields
                    .map((field) => item[field])
                    .filter(Boolean)
                    .join("|"),
                  value: item?.[isPK],
                  ...item,
                },
              ]
            : arrayValues.map((val) => {
                const clonedItem = { ...item, [arrayField]: val };
                return {
                  label: displayFields
                    .map((field) => clonedItem[field])
                    .filter(Boolean)
                    .join("|"),
                  value: clonedItem?.[isPK],
                  ...clonedItem,
                };
              });
        });
        newData = {
          options,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 15 : page,
          },
        };
      }

      setTimeout(() => {
        resolve(newData);
      }, 100);
    } catch (error) {
      console.error("Error in loadOptions:", error);
      reject(error);
    }
  });
};
